import gql from 'graphql-tag';

export default gql`
    mutation DeleteCarrier($input: CarrierDeleteRequest) {
        deleteCarrier(input: $input) {
            errors
        }
    }
`;
